import React from 'react';
import {
   FormControl,
   FormControlLabel,
   FormLabel,
   Radio,
   RadioGroup as MuiRadioGroup,
} from '@mui/material';
import {readOnlyContext} from 'common/context/ReadOnlyContext';
import {DropdownObjectOption} from './Dropdown';
import {useController, useFormContext} from 'react-hook-form';
import {SetValueOptions} from 'components/hook-form/helpers';
import {useRegisterLabel} from 'common/context/FormContext';

type RadioOption = {label: string; value: string};

type Props = {
   label?: React.ReactNode;
   name: string;
   options: (RadioOption | DropdownObjectOption)[];
   disabled?: boolean;
   row?: boolean;
   autoFocus?: boolean;
};

interface RadioGroupProps extends Props {
   value: number | string;
   setValue: (v: number | string) => void;
   // touched: boolean;
   // errorText?: string;
}

const RadioGroup = ({
   label,
   name,
   options,
   disabled,
   row = false,
   autoFocus,
   // className,
   value,
   setValue,
}: // touched,
// errorText,
RadioGroupProps) => {
   const readOnly = React.useContext(readOnlyContext);

   const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setValue((event.target as HTMLInputElement).value);
   };

   return (
      <FormControl component="fieldset" disabled={disabled || readOnly}>
         {label && <FormLabel component="legend">{label}</FormLabel>}
         <MuiRadioGroup row={row} name={name} value={value} onChange={handleChange}>
            {options.map((option, i) => (
               <FormControlLabel
                  key={(option as RadioOption).value || (option as DropdownObjectOption).id}
                  value={(option as RadioOption).value || (option as DropdownObjectOption).id}
                  control={<Radio autoFocus={autoFocus && i === 0} inputProps={{autoFocus}} />}
                  label={(option as RadioOption).label || (option as DropdownObjectOption).name}
               />
            ))}
         </MuiRadioGroup>
      </FormControl>
   );
};

const HookFormRadioGroup = (props: Props) => {
   const {
      field: {name, value},
   } = useController({
      name: props.name,
      // defaultValue: '',
   });
   useRegisterLabel(name, props.label as string);

   const {setValue: _setValue} = useFormContext();

   const setValue = React.useCallback(
      (val: number | string) => _setValue(name, val, SetValueOptions),
      [name, _setValue]
   );

   return (
      <RadioGroup
         value={value}
         setValue={setValue}
         // touched={isTouched}
         // errorText={error?.message}
         {...props}
      />
   );
};

export default HookFormRadioGroup;
